import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import { createOrganizationInvitesQueryKey } from '@/utils/queryKeys';
import type {
  GetOrganizationInvitesQuery,
  GetOrganizationInvitesQueryVariables,
} from './useOrganizationInvites.generated';

/** A pending invite as returned to the org owner. */
export type OrgInvite =
  GetOrganizationInvitesQuery['getOrganizationInvites'][number];

const query = gql`
  query GetOrganizationInvites($input: GetOrganizationInvitesInput!) {
    getOrganizationInvites(input: $input) {
      id
      email
      role
      status
      invitedByName
      isExpired
      expiresAt
      createdAt
      name
      phoneNumber
    }
  }
`;

export const useOrganizationInvites = (
  organizationId: string,
  enabled = true
) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: createOrganizationInvitesQueryKey(organizationId),
    enabled: Boolean(organizationId) && enabled,
    staleTime: 10_000,
    queryFn: () => {
      return gqlClient.request<
        GetOrganizationInvitesQuery,
        GetOrganizationInvitesQueryVariables
      >(query, { input: { organizationId } });
    },
  });

  return {
    invites: data?.getOrganizationInvites ?? [],
    isLoading,
    isError,
  };
};
